'use strict';

const alertMessage = require('../utils/alertMessage');


const SELECTORS = {
    jnextModal: '#modalSoftBenefit',
    jnextBtn: '.js-jnext-open-modal',
    jnextIframe: '.js-jnext-iframe',
    dataset: '#js-page-dataset'
}

if ($(SELECTORS.jnextBtn) && $(SELECTORS.jnextBtn).length > 0 && $(SELECTORS.jnextIframe) && $(SELECTORS.jnextIframe).length > 0) {
    let dataset = $(SELECTORS.dataset);

    $(SELECTORS.jnextBtn).on('click', function (e) {
        $.spinner().start();
        
        sendAnalyticsEvt();

        $.ajax({
            url: dataset.data('jnext'),
            method: 'POST',
            success: function (response) {
                if (response.error) {
                    $.spinner().stop();
                    alertMessage(response.errorMessage, 'cc-alert--danger');
                    return;
                }

                let iframeUrl = response.iframeUrl
                    .replace('[access_token]', response.access_token)
                    .replace('[refresh_token]', response.refresh_token);

                $(SELECTORS.jnextIframe).attr('src', iframeUrl);
                $(SELECTORS.jnextIframe).removeAttr('aria-hidden');
                $(SELECTORS.jnextIframe).removeAttr('tabindex');
                $.spinner().stop();
            },
            error: function (xhr, status, error) {
                console.error(error);
                $.spinner().stop();
            }
        });
    });

    $(SELECTORS.jnextModal).on('hide.bs.modal', function (e) {
        $(SELECTORS.jnextIframe).attr('src', '');
        $(SELECTORS.jnextIframe).attr('aria-hidden', 'true');
        $(SELECTORS.jnextIframe).attr('tabindex', '-1');
    });

    function sendAnalyticsEvt() {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: "generic_event",
                event_category:"jnext_benefit",
                event_label: "My account"
            });
        }
    }

}